class Accessibility {
    init() {
        this.backToTop();
    }

    backToTop() {
        document.querySelector('#back-to-top').addEventListener('click', e => {
            window.scroll({top: 0, left: 0, behavior: 'smooth'});
        });
    }
}

export default Accessibility;